import React, { useEffect, useState } from 'react'
import { Modal, Spin, Button } from 'antd'

import { GiHockey } from 'react-icons/gi'
import { DeleteOutlined } from '@ant-design/icons'
import {
  assignPlayerToStarter,
  getPlayersByPosition,
  removePlayerFromStarter,
} from '../../redux/actions/depthChartAction'
import { useSelector } from 'react-redux'
import { MdLock } from 'react-icons/md'

const DepthChart = ({ openModal, setOpenModal, data: propsData, getDepthChartData }) => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const [loading, setLoading] = useState(true)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [data, setData] = useState([])
  const [starter, setStarter] = useState(null)
  const [playerId, setPlayerId] = useState('')

  const closeModal = () => {
    setPlayerId('')
    setOpenModal(false)
    setData([])
    setStarter(null)
  }

  const getData = async () => {
    setLoading(true)

    const res = await getPlayersByPosition({
      position: propsData.Position ? propsData.Position : '',
      classKey: propsData?.classKey ? propsData?.classKey : '',
      date: SETTING?.date,
    })
    if (res) {
      setStarter(res?.starterPlayer)
      setData(res?.bench)
    }
    setLoading(false)
  }

  useEffect(() => {
    openModal && getData()
  }, [openModal])

  const handleStarter = async (id) => {
    setPlayerId(id)
    const res = await assignPlayerToStarter({
      oldPlayerId: starter?.player?._id ? starter?.player?._id : '',
      playerId: id,
      classKey: propsData?.classKey,
    })
    if (res) {
      closeModal()
      await getDepthChartData()
    }
  }

  const handleRemoveStarter = async (id) => {
    setDeleteLoading(true)
    const res = await removePlayerFromStarter(id)
    if (res) {
      // await getData()
      closeModal()
      await getDepthChartData()
    }
    setDeleteLoading(false)
  }

  const Spinner = () => {
    return (
      <div className='depth_modal_spinner'>
        <Spin />
      </div>
    )
  }

  const Card = ({ data, button = false }) => {
    const { player: p } = data

    return (
      <div className='content_body'>
        <div className='image_box'>
          {p?.player_id?.HostedHeadshotNoBackgroundUrl ? (
            <img src={p?.player_id?.HostedHeadshotNoBackgroundUrl} />
          ) : (
            <GiHockey size={35} color={'#c4c4c4'} />
          )}
        </div>
        <div>
          <p className='text1'>Team</p>
          <p className='text2'>{p?.player_id?.Team || '-'}</p>
        </div>
        <div>
          <p className='text1'>POS</p>
          <p className='text2'>{p?.player_id?.Position || '-'}</p>
        </div>
        <div>
          <p className='text1'>Player Name</p>
          <p className='text2'>{p?.player_id?.Name || '-'}</p>
        </div>
        <div>
          <p className='text1'>Injury</p>
          <p className='text2'>{p?.player_id?.InjuryStatus || '-'}</p>
        </div>
        <div>
          <p className='text1'>OPP</p>
          <p className='text2'>{p?.player_id?.Opponent || '-'}</p>
        </div>
        <div>
          <p className='text1'>PF</p>
          <p className='text2'>{p?.player_id?.pf?.toFixed(2) || '-'}</p>
        </div>
        <div>
          <p className='text1'>APF</p>
          <p className='text2'>{p?.player_id?.avgPf?.toFixed(2) || '-'}</p>
        </div>
        <div>
          <p className='text1'>Projection</p>
          <p className='text2'>{p?.player_id?.Projection || '-'}</p>
        </div>
        {!button && (
          <span>
            {deleteLoading ? (
              <Spin />
            ) : (
              <Button
                shape='circle'
                icon={
                  <DeleteOutlined
                    style={{
                      fontSize: '20px',
                      color: 'red',
                    }}
                  />
                }
                onClick={() => handleRemoveStarter(data?._id)}
              ></Button>
            )}
          </span>
        )}
        {button && (
          <Button
            type='primary'
            className='add_starter_button'
            loading={playerId === p?.player_id?._id ? true : false}
            onClick={() => handleStarter(p?.player_id?._id)}
            disabled={p?.isPlayerLocked}
            icon={p?.isPlayerLocked ? <MdLock size={22} color={'#fff'} /> : false}
          >
            {p?.isPlayerLocked ? '' : 'Add to Starter'}
          </Button>
        )}
      </div>
    )
  }

  return (
    <Modal
      centered
      open={openModal}
      onCancel={closeModal}
      footer={null}
      closeIcon={false}
      className='depth_modal'
      closable={false}
    >
      <div className='depth_modal_content'>
        <div className='card_box'>
          <div className='header' style={{ marginBottom: starter ? '0px' : '20px' }}>
            <h2>Starter</h2>
            <h2 style={{ textTransform: 'uppercase' }}>{propsData?.Position}</h2>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            !!starter && (
              <Card
                data={{
                  ...starter,
                  player: {
                    player_id: starter?.player,
                  },
                }}
              />
            )
          )}
        </div>
        <div className='card_box'>
          <div className='header'>
            <h2>Bench</h2>
          </div>
          <div className='scroll_section'>
            {loading ? (
              <Spinner />
            ) : (
              data?.length > 0 &&
              data?.map((v, i) => {
                return (
                  <Card
                    button={true}
                    key={i}
                    data={{ player: { ...v } }}
                    handleStarter={handleStarter}
                  />
                )
              })
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DepthChart
